import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

function regexpValidatorFactory(regexp, invalidKey) {
	if (_.isString(regexp)) {
		regexp = new RegExp(regexp, 'u')
	}
	function regexpValidator(value) {
		if (_.isEmpty(value)) {
			return
		}

		if (!regexp.test(value)) {
			return i18n.get(invalidKey)
		}
	}
	return regexpValidator
}

export default regexpValidatorFactory

regexpValidatorFactory.__filename__ = 'components/validators/regexp-validator-factory.js'
